import React, { useCallback } from 'react';
import type { FC } from 'react';
import LayoutAuth from './LayoutAuth';
import PasswordRecoveryBody from './PasswordRecoveryBody';
import { ResetPasswordInput } from '~/gen/api/user';
import retrieveAxiosErr from '~/utils/retrieveAxiosErr';
import { SaveAction } from '~/dataProvider/types';
import { executeRecaptcha } from '~/sideEffects/recaptcha';
import { RecPatch, SupportedResources } from '~/dataProvider/tools';
import { useCreate } from 'ra-core';
import { useResourceRegister } from '~/utils/resourceRegister';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import chainOptions from '~/utils/chainOptions';


const PasswordRecovery: FC = () => {
  const dispatch = useDispatch()
  const resource: SupportedResources = 'resetpassword'
  
  useResourceRegister({ name: resource })
  const [sendReset,] = useCreate<ResetPasswordInput & RecPatch>(resource)
  const submit: SaveAction<string> = useCallback(async (email, redirct, options) => {
    try
    {
      const recaptchaResp = await executeRecaptcha('resetpassword')
      await sendReset(resource, { email, recaptchaResponse: recaptchaResp }, chainOptions(options, {
        onSuccess: () =>
          Promise.resolve(options && options.onSuccess && options.onSuccess())
            .then(() => {
              dispatch(push(`/reset-password-sent?email=${email}`))
            })
      }))
    }
    catch(err) {
      const errMsg = retrieveAxiosErr(err)
      
      return Promise.resolve(options && options.onFailure && options.onFailure(errMsg))
    }

  }, [dispatch, sendReset])


  return (
    <LayoutAuth>
      <div role="main">
        <PasswordRecoveryBody submit={submit} />
      </div>
    </LayoutAuth>
  );
};

export default PasswordRecovery;
